import { Injectable } from '@angular/core';
import { ApiService } from '../api.service';
import { Observable } from 'rxjs';
import { HydraCollection } from '../hydra/hydra-collection';


@Injectable({
  providedIn: 'root'
})
export class TeamsApiService extends ApiService {
  readonly resourcePath = 'organisation_profile_teams';

  list(id:string): Observable<HydraCollection<any>> {
    return this.restList<any>({'organisationProfile': '/organisation_profiles/'+id, 'order[name]': 'ASC','pagination':'false'});
  }

  get(id: string): Observable<any> {
    return this.restRead<any>(id);
  }

  update(id:string,data:object){
    return this.restUpdate(id,data);
  }

  create(data:object){
    return this.restCreate(data);
  }
  delete(id:string){
    return this.restDelete(id);
  }
}
